// @flow

import React, {Component} from 'react';

import styled from 'styled-components';
import notification from 'antd/lib/notification';

import {vehicleIssueGroupApi} from './../../lib/api';
import {getPathWithHistoryParams, navigate} from './../../lib/helpers';

import {Panel} from './../../components/layout';
import Header from './../../components/layout/Header';
import Breadcrumbs, {Crumb} from './../../components/layout/Breadcrumbs';
import {notificationLoading} from './../../components/Notifications';

import InnerForm from './components/InnerForm';
import type {VehicleIssueGroup} from '../../lib/types/vehicleIssueGroup';

const StyledPanel = styled(Panel)`
  padding-top: 0;
`;

type Props = {
  id: ?string
};

type State = {
  vehicleIssueGroup: ?VehicleIssueGroup
};

class VehicleIssueGroupForm extends Component<Props, State> {
  state = {
    vehicleIssueGroup: null
  };

  async componentDidMount() {
    let id = parseInt(this.props.id, 10);
    if (id) {
      try {
        const vehicleIssueGroup = await vehicleIssueGroupApi.getVehicleIssueGroup(
          id
        );
        this.setState({ vehicleIssueGroup });
      } catch (error) {
        notification.error({
          message: 'Ошибка',
          description: error.message
        });
      }
    }
  }

  onSubmit = async (values: any) => {
    try {
      notificationLoading({
        message: 'Сохранение данных...',
        key: 'saving'
      });
      if (this.props.id) {
        await vehicleIssueGroupApi.updateVehicleIssueGroup(values);
      } else {
        await vehicleIssueGroupApi.addVehicleIssueGroup(values);
      }
      notification.success({
        message: 'Успешно сохранено',
        description: 'Изменения успешно сохранены'
      });
      navigate('/admin/vehicle-issue-group', true);
    } catch (error) {
      notification.error({
        message: 'Ошибка',
        description: error.message
      });
    } finally {
      notification.close('saving');
    }
  };

  onCancel = () => navigate('/admin/vehicle-issue-group', true);

  render() {
    const { vehicleIssueGroup } = this.state;
    const { id } = this.props;
    return (
      <>
        <Header
          left={
            <Breadcrumbs>
              <Crumb
                to={getPathWithHistoryParams('/admin/vehicle-issue-group')}
              >
                Список групп дефектов
              </Crumb>
              {id ? (
                <Crumb to={`/admin/vehicle-issue-group/edit/${id}`}>
                  Группы дефектов №{id}
                </Crumb>
              ) : (
                <Crumb to={`/admin/vehicle-issue-group/new`}>
                  Новая группа дефектов
                </Crumb>
              )}
            </Breadcrumbs>
          }
        />
        <StyledPanel>
          <h1>{id ? `Группа дефектов №${id}` : `Новая группа дефектов`}</h1>
        </StyledPanel>
        <InnerForm
          vehicleIssueGroup={vehicleIssueGroup}
          onSubmit={this.onSubmit}
          onCancel={this.onCancel}
        />
      </>
    );
  }
}

export default VehicleIssueGroupForm;
